import { Utilities } from "../Utilities/Utilities";
import WSManager from "./WSManager";
import * as WSC from "./WSConstants";

const S3_URL_PREFIX = WSC.S3_BUCKET_PATH + "appstatic/" + WSC.BUCKET_DATA_PREFIX;
const AppLANG = '_' + WSManager.getAppLang();

export function getMasterData(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "mobile_app_master_data.json";
    // var s3_api_data_url = S3_URL_PREFIX + "app_master_data.json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.MASTER_DATA, params)
}
export function loadLanguageResource(data) {
    let params = data ? data : {}
    var s3_api_data_url = WSC.S3_BUCKET_PATH + "assets/i18n/translations/" + params.lang_code + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, '', '')
}
export function getStaticPageData(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "static_page_" + params.page_alias + AppLANG + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.STATIC_PAGE_DATA, params)
}
export function getRulePageData(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "scoring_master_data_" + params.sports_id + AppLANG + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_SCORING_MASTER_DATA, params);
}
export function getFilterData(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_FILTER_MASTER_DATA, params);
}
export function getLobbyBanner(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "lobby_banner_list_" + params.sports_id + AppLANG + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LOBBY_BANNER_LIST, params);
}
export function getContestDetails(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_CONTEST_DETAIL, params);
}
export function getUserContestJoinCount(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_GAME_USER_JOIN_COUNT, params);
}
export function getContestUserList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_CONTEST_USERS, params);
}
export function getLobbyFixtures(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "lobby_fixture_list_" + params.sports_id + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LOBBY_FIXTURE, params);
    // let params = data ? data : {}
    // return WSManager.Rest(WSC.fantasyURL + WSC.GET_LOBBY_FIXTURE, params);
}

export function getFixtureDetail(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_FIXTURE_DETAIL, params);
}
export function getUserTeams(data, user_unique_id) {
    let params = data ? data : {}
    // var s3_api_data_url = S3_URL_PREFIX + "user_teams_" + params.collection_master_id + "_" + user_unique_id + ".json";
    // return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_USER_LINEUP_LIST, params);
    return WSManager.RestS3ApiCall('', WSC.GET_USER_LINEUP_LIST, params);
}
export function getLineupMasterData(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "lineup_master_data_" + params.collection_master_id + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LINEUP_MASTER_DATA, params);
}
export function getRosterList(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "collection_roster_list_" + params.collection_master_id + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_ALL_ROSTER, params);
}
export function getPlayerCard(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_PLAYERCARD, params);
}
export function getPlayerBreakdown(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_PLAYER_BREAKDOWN, params);
}
export function checkContestEligibility(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.CHECK_ELIGIBILITY_FOR_CONTEST, params);
}
export function getUserLineUps(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_USER_LINEUP_LIST, params);
}
export function getUserLineUpDetail(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_USER_LINEUP, params);
}
export function getFixtureContestList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_FIXTURE_CONTEST_LIST, params)
}
export function getReferralData(data) {
    let params = data ? data : {};
    params['apiversion'] = 'v2';
    return WSManager.Rest(WSC.userURL + WSC.GET_SIGNUP_REFERRAL_DATA, params)
}
export function getNewTeamName(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_USER_LINEUP_TEAM_NAME, params);
}
export function getMyCollection(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MY_COLLECTION_LIST, params, cacheEnable);
}
export function getMyContest(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MY_CONTEST_LIST, params, cacheEnable);
}
export function processLineup(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.LINEUP_PROCCESS, params);
}
export function getUserBalance(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_USER_BALANCE, params);
}
export function validateFundPromo(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.VALIDATE_PROMO_CODE, params);
}
export function withdrawAmount(data) {
    let params = data ? data : {}
    params['apiversion'] = 'v2';
    // return WSManager.Rest(WSC.userURL + WSC.WITHDRAW_BALANCE, params);
    return WSManager.RestTemp(WSC.userNewURL + WSC.WITHDRAW_BALANCE_NEW, params);
}
export function withdrawPending(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_PENDING_WITHDRAW, params);
}
export function depositPaytmFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DEPOSIT_BY_PAYTM, params);
}
export function depositGocashFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DEPOSIT_BY_GOCASH, params);
}
export function depositJustPayFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DEPOSIT_BY_JUSTPAY, params);
}
export function depositPayPalFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DEPOSIT_BY_PAYPAL, params);
}
export function depositIPAYFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DEPOSIT_BY_IPAY, params);
}
export function depositPayStackFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.baseURL + WSC.DEPOSIT_BY_PAYSTACK, params);
}
export function depositPayUmoneyFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DEPOSIT_BY_PAYUMONEY, params);
}
export function getTranscationHistory(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_TRANSACTION_HISTORY, params);
}
export function getPredictionHistory(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.predictionBaseUrl + WSC.GET_USER_PREDICTION_TRANSACTIONS, params);
}
export function validateContestPromo(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.VALIDATE_CONTEST_PROMO_CODE, params);
}
export function joinContest(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.JOIN_FANTASY_CONTEST_GAME, params);
}
export function joinContestWithMultiTeam(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.MULTITEAM_JOIN_GAME, params);
}
export function userLogin(data) {
    let params = data ? data : {}
    let api = Utilities.getMasterData().login_flow === '1' ? WSC.EMAIL_LOGIN : WSC.LOGIN;
    return WSManager.Rest(WSC.userURL + api, params)
}
export function logoutUser(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_LOGOUT, params)
}
export function editMobile(data) {
    let params = data ? data : {}
    let api = WSC.EDIT_MOBILE;
    return WSManager.Rest(WSC.userURL + api, params)
}
export function verifyEditedMobile(data) {
    let params = data ? data : {}
    let api = WSC.VERIFY_EDITED_MOBILE;
    return WSManager.Rest(WSC.userURL + api, params)
}
export function editEmail(data) {
    let params = data ? data : {}
    let api = WSC.EDIT_EMAIL;
    return WSManager.Rest(WSC.userURL + api, params)
}
export function verifyEditedEmail(data) {
    let params = data ? data : {}
    let api = WSC.VERIFY_EDITED_EMAIL;
    return WSManager.Rest(WSC.userURL + api, params)
}
export function updateSignupData(data) {
    let params = data ? data : {}
    let api = Utilities.getMasterData().login_flow === '1' ? WSC.UPDATE_EMAIL_SIGNUP_DATA : WSC.UPDATE_SIGNUP_DATA;
    return WSManager.Rest(WSC.userURL + api, params)
}
export function validateLogin(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.VALIDATE_LOGIN, params)
}
export function socialLogin(data) {
    let params = data ? data : {}
    let api = Utilities.getMasterData().login_flow === '1' ? WSC.SOCIAL_EMAIL_LOGIN : WSC.SOCIAL_LOGIN;
    return WSManager.Rest(WSC.userURL + api, params)
}
export function updateDeviceToken(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_DEVICE_TOKEN, params)
}
export function updateUserProfile(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_PROFILE, params)
}
export function verifyUserPan(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.VERIFY_PAN_INFO, params)
}
export function verifyUserBank(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.VERIFY_BANK_ACCOUNT, params)
}
export function updateStateDetail(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_STATE_DATA, params)
}
export function updatePANCardDetail(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_PAN_INFO, params)
}
export function updateUserBankDetail(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_BANK_ACC_DETAILS, params)
}
export function deleteUserBankDetail(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DELETE_BANK_ACC_DETAILS, params)
}
export function getUserProfile(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_MY_PROFILE, params)
}
export function activateAccount(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.ACTIVATE_ACCOUNT, params)
}
export function getAppStoreLink(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_DOWNLOAD_APP_LINK, params)
}
export function getResendEmailVerLink(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.RESEND_EMAIL_VERIFICATION_LINK, params)
}
export function validatePhoneOTP(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.VALIDATE_OTP, params)
}
export function validateEmailOTP(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.VALIDATE_EMAIL_OTP, params)
}
export function resendPhoneOTP(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.RESEND_OTP, params)
}
export function resendEmailOTP(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.RESEND_EMAIL_OTP, params)
}
export function getAllCountries(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "country_list.json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_ALL_COUNTRY, params);
}
export function getAllStates(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "state_list_" + params.master_country_id + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_ALL_STATE, params);
}
export function changePassword(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.CHANGE_PASSWORD, params);
}
export function forgotPassword(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.FORGOT_PASSWORD, params);
}
export function validateForgotPassword(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.VALIDATE_FORGOT_PASSWORD, params);
}
export function resetForgotPassword(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.RESET_PASSWORD, params);
}
export function getAppNotificationCount(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_UNREAD_NOTIFICATION, params);
}
export function getNotification(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_USER_NOTIFICAITONS, params);
}
export function getContestShareCode(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_INVITE_CODE, params);
}
export function getShortURL(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_SHORTENED_URL, params);
}
export function saveShortURL(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_SAVE_SHORTEN_URL, params);
}
export function getPublicContestDetail(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_PUBLIC_CONTEST, params);
}
export function checkUsername(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.CHECK_USERNAME_AVAIBILITY, params);
}
export function updateUsername(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_USERNAME, params);
}
export function getMyReferralList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_AFFILIATE_MYREFERRAL_LIST, params);
}

export function getUserEarnMoney(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_USER_EARN_MONEY, params);
}
export function getReferralMasterData(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_AFFILIATE_MASTER_DATA, params);
}
export function getMasterDataRef(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_MASTER_DATA_REF, params);
}
export function updateRefCode(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_REF_CODE, params);
}
export function playingExperience(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.PLAYING_EXPERIENCE, params);
}
export function getSwitchTeamList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_USER_SWITCH_TEAM_LIST, params);
}
export function switchTeamContest(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.SWITCH_TEAM_CONTEST, params);
}
export function downloadContestTeam(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_CONTEST_LINEUP_EXPORT, params);
}
export function getLineupWithScore(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_LINPEUP_WITH_SCORE, params);
}
export function getContestLeaderboard(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_CONTEST_LEADERBOARD, params);
}
export function getOwnLeaderboard(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_CONTEST_USER_LEADERBOARD, params);
}
export function getDealsAPI(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_DEALS, params);
}
export function getMatchByLeague(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MATCHES_BY_LEAGUE_ID, params);
}
export function createPrivateContest(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.CREATE_USER_CONTEST, params);
}
export function createContestMasterData(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.CREATE_CONTEST_MASTER_DATA, params);
}

/*=======Coins======*/
export function getDailyCoins(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_DAILYCOIN, params);
}
export function claimCoins(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.CLAIM_COINS, params);
}
export function getEarnCoinsList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.EARN_COIN_LIST, params);
}
export function getRewardList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_REWARD_LIST, params);
}
export function redeemRewards(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.REDEEM_REWARD, params);
}
export function updateUserSettings(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.UPDATE_USER_SETTING, params);
}
export function getFeedbackQA(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_FB_LIST, params);
}
export function saveFeedback(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.SAVE_FEEDBACK, params);
}

/*========Multigame==========*/


export function getLobbyMultiGame(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "lobby_fixture_list_multigame_" + params.sports_id + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LOBBY_MULTI_GAME, params);
}
export function getFixtureDetailMultiGame(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_FIXTURE_DETAIL_MULTI_GAME, params);
}

export function getContestDetailsMultiGame(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_CONTEST_DETAIL_MULTI_GAME, params);
}

export function getPublicContestDetailMultiGame(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_PUBLIC_CONTEST_MULTI_GAME, params);
}
export function getMyCollectionMultiGame(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MY_COLLECTION_LIST_MULTI_GAME, params, cacheEnable);
}
export function checkContestEligibilityMultiGame(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.CHECK_ELIGIBILITY_FOR_CONTEST_MULTI_GAME, params);
}


/*==================*/

/*=========Prediction=========*/

export function getLobbyPrediction(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "lobby_fixture_list_prediction_" + params.sports_id + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LOBBY_PREDICTION, params);
}
export function getLobbyPredictionNew(data) {
    let params = data ? data : {}
    // var s3_api_data_url = S3_URL_PREFIX + "lobby_fixture_list_prediction_" + params.sports_id + ".json";
    return WSManager.Rest(process.env.REACT_APP_PREDICTION_BASE_URL+ WSC.GET_LOBBY_PREDICTION_NEW, params)
    // return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LOBBY_PREDICTION, params);
}

export function getSeasonBySeaonUid(data) {
    let params = data ? data : {}
    // var s3_api_data_url = S3_URL_PREFIX + "lobby_fixture_list_prediction_" + params.sports_id + ".json";
    return WSManager.Rest(process.env.REACT_APP_BASE_URL+ WSC.GET_SEASON_BY_SEASON_UID, params)
    // return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LOBBY_PREDICTION, params);
}

export function getPredictionContest(data) {
    let params = data ? data : {}
    return WSManager.Rest(process.env.REACT_APP_NODE_URL + WSC.GET_PREDICTIONS_CONTEST, params)
}
export function getPredictionContestNew(data) {
    let params = data ? data : {}
    return WSManager.Rest(process.env.REACT_APP_PREDICTION_BASE_URL + WSC.GET_PREDICTIONS, params)
}

export function makePrediction(data) {
    let params = data ? data : {}
    
    return WSManager.Rest(process.env.REACT_APP_BASE_URL + WSC.MAKE_PREDICTIONS, params)
}
export function makePredictionNew(data) {
    let params = data ? data : {}
    
    return WSManager.Rest(process.env.REACT_APP_PREDICTION_BASE_URL + WSC.MAKE_PREDICTIONS_NEW, params)
}

export function getPredictionSeason(data) {
    let params = data ? data : {}
    return WSManager.Rest(process.env.REACT_APP_NODE_URL + WSC.PREDICTIONS_SEASON, params)
}
export function getPredictionSeasonNew(data) {
    let params = data ? data : {}
    return WSManager.Rest(process.env.REACT_APP_PREDICTION_BASE_URL + WSC.GET_MY_PREDICTION_SEASON, params)
}

export function getMyPrediction(data) {
    let params = data ? data : {}
    return WSManager.Rest(process.env.REACT_APP_NODE_URL + WSC.MY_PREDICTIONS, params)
}

export function getMyPredictionNew(data) {
    let params = data ? data : {}
    return WSManager.Rest(process.env.REACT_APP_PREDICTION_BASE_URL + WSC.GET_MY_CONTEST_FIXTURE_PREDICTIONS, params)
}

export function getPredictionDetail(data) {
    let params = data ? data : {}
    return WSManager.Rest(process.env.REACT_APP_NODE_URL + WSC.GET_PREDICTIONS_DETAIL, params)
}

export function getPredictionParticipants(data) {
    let params = data ? data : {};
    let url = params.isLeader ? WSC.GET_PREDICTION_LEADERBORD : WSC.GET_PREDICTION_USERS
    return WSManager.Rest(WSC.baseURL + url, params)
}

export function getPredictionParticipantsNew(data) {
    let params = data ? data : {};
    let url = WSC.GET_PREDICTION_LEADERBORD_NEW
    return WSManager.Rest(WSC.predictionBaseUrl + url, params)
}

export function checkIsPredictionJoin(data) {
    let params = data ? data : {};
    return WSManager.Rest(process.env.REACT_APP_NODE_URL + WSC.CHECK_PREDICTION_JOINED, params)
}

/*=========FREE TO PLAY=========*/

export function getLobbyFreeToPlay(data) {
    let params = data ? data : {}
    var s3_api_data_url = S3_URL_PREFIX + "f2p_fixture_list_" + params.sports_id + ".json";
    return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_LOBBY_FREE_TO_PLAY, params);
   
}
export function getMiniLeagueUpcomingFixture(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MINI_LEAGUE_UPCOMING_FIXTURE, params, cacheEnable);
}

export function getMyContestFreeToPlay(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MY_CONTEST_LIST_FREE_TO_PLAY, params, cacheEnable);
}
export function getMiniLeagueByStatus(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MINI_LEAGUE_BY_STATUS, params, cacheEnable);
}
export function getMiniLeagueDetails(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MINI_LEAGUE_DETAILS, params, cacheEnable);
}
export function getFixtureMiniLeague(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_FIXTURE_MINI_LEAGUE, params)
}
export function getMiniLeagueLeaderBoard(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GTE_MINI_LEAGUE_LEADER_BOARD, params);
}
export function getUserMiniLeagueLeaderBoard(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GTE_USER_MINI_LEAGUE_LEADER_BOARD, params);
}
export function getUserMiniLeagueLeaderBoardMatches(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GTE_USER_MINI_LEAGUE_LEADER_BOARD_MATCHES, params);
}
export function getMiniLeagueMyContest(data, cacheEnable) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_MINI_LEAGUE_MY_CONTEST_LIST, params, cacheEnable);
}

export function depositRazorPayFund(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.DEPOSIT_BY_RAZORPAY, params);
}

export function getCoinPackageList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_COINS_PACKAGE_LIST, params);
}
export function callBuyCoins(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.BUY_COINS, params);
}
export function getCashFreeGatewayList(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_CASHFREE_GATWAY_LIST, params);
}

//Refereal
export function getReferalLeaderboard(data) {
    let params = data ? data : {};
    return WSManager.Rest(process.env.REACT_APP_BASE_URL + WSC.GET_REFERAL_LEADERBOARD, params)
}
export function getReferalPrizes(data) {
    let params = data ? data : {};
    return WSManager.Rest(process.env.REACT_APP_BASE_URL + WSC.GET_REFERAL_PRIZES, params)
}
//Network Fantasy
export function joinContestNetworkfantasy(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.JOIN_FANTASY_CONTEST_GAME_NETWORK_FANTASY, params);
}
export function getPublicContestNetworkfantasy(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.baseURL + WSC.GET_PUBLIC_CONTEST_NF, params);
 }

export function getContestDetailsNetworkfantasy(data) {
   let params = data ? data : {}
   var s3_api_data_url = S3_URL_PREFIX + "contest_detail_" + params.contest_id + AppLANG + ".json";
   return WSManager.RestS3ApiCall(s3_api_data_url, WSC.GET_CONTEST_DETAIL_NETWORK_FANTASY, params);
  //return WSManager.Rest(WSC.baseURL + WSC.GET_CONTEST_DETAIL_NETWORK_FANTASY, params)

}
export function getUserContestJoinCountNetworkfantasy(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_GAME_USER_JOIN_COUNT_NETWORK_FANTASY, params);
}

export function getContestUserListNetworkfantasy(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_CONTEST_USERS_NETWORK_FANTASY, params);
}
export function getContestShareCodeNF(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_INVITE_CODE_NF, params);
}
export function getLineupWithScoreNF(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_LINPEUP_WITH_SCORE_NF, params);
}
/*=========Contest SCORE CARD =========*/
export function getContestScoreCard(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_CONTEST_SCORE_CARD, params);

}
export function getTDSNotes() {
    var s3_api_data_url = WSC.S3_BUCKET_PATH + "notes" + "/tds.json";
    return WSManager.RestS3ApiCall(s3_api_data_url, '', '')
}

export function getSwitchTeamListNF(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_USER_SWITCH_TEAM_LIST_NF, params);
}
export function downloadContestTeamNF(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_CONTEST_LINEUP_EXPORT_NF, params);
}
export function getContestLeaderboardNF(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_CONTEST_LEADERBOARD_NF, params);
}
export function getOwnLeaderboardNF(data) {
   let params = data ? data : {}
   return WSManager.Rest(WSC.baseURL + WSC.GET_CONTEST_USER_LEADERBOARD_NF, params);
}

export function switchTeamContestNF(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.SWITCH_TEAM_CONTEST_NETWORK_FANTASY, params);
}

export function joinContestWithMultiTeamNF(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.MULTITEAM_JOIN_GAME_NETWORK_FANTASY, params);
}
export function getPlayerBreakdownNF(data) {
    let params = data ? data : {}
    return WSManager.RestS3ApiCall('', WSC.GET_PLAYER_BREAKDOWN_NETWORK_FANTASY, params);
}

//Team Compare

export function getLineupWithTeamCompare(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.GET_LINPEUP_WITH_TEAM_COMPARE, params);
}
// Session tracking 
export function updateTrackActiveSession(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.fantasyURL + WSC.TRACK_ACTIVE_SESSION, params);
}

export function getContestScoreCardNF(data) {
    let params = data ? data : {}
    return WSManager.Rest(WSC.userURL + WSC.GET_CONTEST_SCORE_CARD_NETWORK_FANTASY, params);

}